<template>
  <div class="build-step reply-with-bids">
    <div class="title">
      <div class="move-handle">
        <icon type="dots-vertical" size="24px" />
      </div>
      <div class="name">Normalize Algo Source Id</div>
      <delete-action
          text
          rounded
          icon="close"
          message="Are you sure you want to remove this build step?"
          tooltip="Remove Build Step"
          @delete="removeBuildStep"
      />
    </div>
    <div class="description">
      This step allows for the algo source segments to be created.
      Select which source_types (web, partner etc) should have this source data added.
      Specify which source REGEX should be using keywords CR.
    </div>
    <div class="step-settings">
      <h3>Settings</h3>
      <div class="control-group">
        <div class="inner">
          <label class="control-label">Source Types:</label>
          <div class="field">
            <p-multi-select
                v-model="modelValue.source_types"
                :options="source_type_options"
                option-label="label"
                option-value="value"
                showClear
                placeholder="Type"
            />
          </div>
        </div>
      </div>
      <div class="control-group">
        <div class="inner">
          <label class="control-label">Source Ids using Keywords</label>
          <div class="controls">
            <div class="field">
              <p-chips
                  v-model="modelValue.keyword_sources"
                  separator=","
                  placeholder="Add source id regexes that need to use keyword CR category"
                  add-on-blur
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import deleteAction from '@/components/widgets/DeleteAction.vue';
import pChips from "primevue/chips";
import { source_type_options } from "@/lib/Options";

export default {
  name: 'NormalizeAlgoSourceId',
  emits: ['remove'],
  components: {
    pChips,
    deleteAction,
  },
  props: {
    modelValue: {
      type: Object,
      default: {
        keyword_sources: [],
        source_types: []
      },
    },
  },
  data() {
    return {
      source_type_options
    }
  },
  methods: {
    removeBuildStep() {
      this.$emit('remove');
    },
  },
};
</script>
